import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { LogOut } from 'lucide-react';
import { authService } from '../api/auth';

const LogoutPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    void authService.logout();
    sessionStorage.removeItem('token');

    const timer = setTimeout(() => {
      navigate('/');
    }, 2000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center pb-16 md:pb-0">
      <div className="max-w-md w-full bg-white shadow rounded-lg p-8 text-center">
        <LogOut className="mx-auto h-16 w-16 text-indigo-600" />
        <h1 className="mt-4 text-2xl font-bold text-gray-900">Logging out...</h1>
        <p className="mt-2 text-gray-600">
          You are being logged out. You will be redirected to the home page shortly.
        </p>
        <div className="mt-6">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600 mx-auto"></div>
        </div>
      </div>
    </div>
  );
};

export default LogoutPage;